module.exports = __webpack_public_path__ + "static/media/rnaui_106.5ee1d48b.ico";